"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getCheckboxUtilityClass = getCheckboxUtilityClass;

var _utils = require("@mui/utils");

var _generateUtilityClass = _interopRequireDefault(require("../generateUtilityClass"));

function getCheckboxUtilityClass(slot) {
  return (0, _generateUtilityClass.default)('MuiCheckbox', slot);
}

const checkboxClasses = (0, _utils.unstable_generateUtilityClasses)('MuiCheckbox', ['root', 'checked', 'disabled', 'indeterminate', 'colorPrimary', 'colorSecondary']);
var _default = checkboxClasses;
exports.default = _default;